import { Button, Colors } from '@user-portal/wikr-components';

import { selectIsBlackBtn } from 'helpers/abTests';

import * as S from 'components/Buttons/OutlinedButton/styled';

type OutlinedButtonPropsType = {
    text: string;
    onClick: () => void;
    dataLocator?: string;
    mb?: number;
    isLoading?: boolean;
    backgroundColor?: Colors;
};

const OutlinedButton = ({ text, onClick, dataLocator, mb, isLoading, backgroundColor }: OutlinedButtonPropsType) => {
    // Todo: YG-3885: Use the real experiment hook when required, or delete this flag once the experiment is over
    const isBlackBtn = selectIsBlackBtn();

    return (
        <S.Container
            $mb={mb}
            $borderColor="border-default"
            $backgroundColor={backgroundColor}
            $borderRadius={isBlackBtn ? 12 : 0}
        >
            <Button
                isLoading={isLoading}
                disabled={isLoading}
                textColor="text-main"
                onClick={onClick}
                dataLocator={dataLocator}
                backgroundColor={backgroundColor}
            >
                {text}
            </Button>
        </S.Container>
    );
};

export default OutlinedButton;
